
import { defineComponent } from 'vue'
import { iDataset, iPythonConfiguration, iLibrary } from '../../../FunctionsCatalog'
import { AxiosResponse } from 'axios'
import FunctionsCatalogDatasetTable from './FunctionsCatalogDatasetTable/FunctionsCatalogDatasetTable.vue'
import FunctionsCatalogDatasetForm from './FunctionsCatalogDatasetForm/FunctionsCatalogDatasetForm.vue'

export default defineComponent({
    name: 'function-catalog-configurator-tab',
    components: { FunctionsCatalogDatasetTable, FunctionsCatalogDatasetForm },
    props: { datasets: { type: Array }, propFunction: { type: Object } },
    emits: ['selected', 'loading', 'selectedEnvironment', 'selectedDataset'],
    data() {
        return {
            selectedDataset: null as iDataset | null,
            pythonEnvironments: [] as iPythonConfiguration[],
            rEnvironments: [] as any[],
            libraries: [] as iLibrary[]
        }
    },
    async created() {
        await this.loadEnvironments()
    },
    methods: {
        async loadSelectedDataset(dataset: iDataset) {
            this.$emit('loading', true)
            await this.$http.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `2.0/datasets/${dataset.label}`).then((response: AxiosResponse<any>) => {
                if (response.data) {
                    this.selectedDataset = response.data[0]
                    this.$emit('selectedDataset', this.selectedDataset)
                }
            })
            this.$emit('loading', false)
        },
        async loadEnvironments() {
            this.$emit('loading', true)
            await this.loadEnvironment('PYTHON_CONFIGURATION').then((response: AxiosResponse<any>) => (this.pythonEnvironments = response.data))
            await this.loadEnvironment('R_CONFIGURATION').then((response: AxiosResponse<any>) => (this.rEnvironments = response.data))
            this.$emit('loading', false)
        },
        loadEnvironment(type: string) {
            return this.$http.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `2.0/configs/category/${type}`)
        },
        async onEnvironmentSelected(environment: string) {
            this.$emit('selectedEnvironment', environment)
            this.$emit('loading', true)
            if (environment && environment.split('.')[0] === 'python') {
                await this.loadEnvironmentLibraries(`2.0/backendservices/widgets/python/libraries/${environment}`).then((response: AxiosResponse<any>) => (this.libraries = JSON.parse(response.data.result)))
            }
            this.$emit('loading', false)
        },
        async loadEnvironmentLibraries(url: string) {
            return this.$http.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `${url}`)
        }
    }
})
